/*
 *
 * PayToCardPopup
 *
 * @version 1.0.0
 * @author Davide Polci
 * @since 02-Oct-2026
 */

import PayToCardPopup from './PayToCardPopupContainer'

export default PayToCardPopup
